import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';


@Injectable()
export class AuthService {

    static parameters = [HttpClient, Router, ToastrService]
    constructor(
        private http: HttpClient,
        private router: Router,
        private toastr: ToastrService,
    ) { }

    public get currentUserValue() {
        return JSON.parse(sessionStorage.getItem('currentUser'));
    }


    login(data: any) {
        return this.http.post('/auth/local', data);
    }

    getProductList() {
        let data = {
            StockistID: 2968,
            legendType: 1
        }

        let queryData = {
            email: 'entero_lucknow',
            password: 'entero@123'
        }
        var http = new XMLHttpRequest();
        var url = 'https://www.enterodirect.com/auth/local';
        var params = 'email=entero_lucknow&password=entero@123';
        http.open('POST', url, true);

        //Send the proper header information along with the request
        http.setRequestHeader('Content-type', 'application/json');
        http.setRequestHeader('Access-Control-Allow-Origin', '*');

        http.onreadystatechange = function () {//Call a function when the state changes.
            alert(http.readyState);
            if (http.readyState == 4 && http.status == 200) {
                alert(http.responseText);
            }
        }
        http.send(params);
        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Content-Type, Authorization"
        };
        // return this.htpclient.post('https://www.enterodirect.com/auth/local', queryData, { headers });
        //   console.log('token', token);
        //   return token;
        // return this.http.post('https://www.enterodirect.com/api/products/getProductlist/',data, {

        // })
    }

    // employeeMaster(data:any)
    // {
    //     let tokenData = JSON.parse(localStorage.getItem("token"));
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     "Content-Type": "application/json",
    //     Authorization: `Bearer ${tokenData.Token}`,
    //   }),
    // };
    //     return this.http.post('',data);
    // }
 
    logout() {
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('currentUser');
    }

    public get loggedIn(): boolean {
        return (sessionStorage.getItem('access_token') !== null);
    }



}
